import apiClient from '../../lib/axios';

export const fetchCostCenters = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/cost-centers?${params.toString()}`);
  return data;
};

export const fetchActiveCostCenters = async () => {
  const { data } = await apiClient.get('/api/cost-centers/active');
  return data;
};

export const createCostCenter = async (payload) => {
  const { data } = await apiClient.post('/api/cost-centers', payload);
  return data;
};

export const updateCostCenter = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/cost-centers/${id}`, payload);
  return data;
};

export const deleteCostCenter = async (id) => {
  const { data } = await apiClient.delete(`/api/cost-centers/${id}`);
  return data;
};

export default fetchCostCenters;
